<div class="nin-verification-prompt">
  <div class="text-center">
    <img src="assets/sad-chat.svg" alt="" />
  </div>

  <div class="content-container">
    <div class="col-12">
      <p class="text-center content-span h2 d-block full-width fw-bold">
        Identity Verification Required
      </p>
    </div>
  </div>

  <div class="content-container">
    <div class="col-12">
      <p class="text-center content-span small full-width fw-bold text-black-50">
        Your NIN has not been verified yet. Please verify your identity to
        continue using Breeze.
      </p>
    </div>
  </div>

  <div class="container mt-5">
    <div
      class="d-flex pb-4 justify-content-center flex-column align-items-center gap-3"
    >
      <div class="p-0 action button-1">
        <button ngbAutofocus (click)="onVerifyNow()">Verify Now</button>
      </div>
    </div>
  </div>
</div>
